import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Modal, Box, Typography } from "@mui/material";
import { get as lodashGet } from "lodash";

import { COLOR } from "config/color";
import { lineOAUrl, customerStatus } from "config/const";
import { ModalStyle, WhiteButton } from "components/Styled";

import { useAuth } from "providers/Auth";
import * as Client from "api/client";

import { GA_UTM_SOURCE, GO_FORM_UTM_SOURCE } from "config/const";
import { useLoading } from "providers/Loading";
import Header from "./Header";
import Logo from "components/Logo";
import Video from "./Video";
import ContentInfo from "./ContentInfo";
import ProductInfoCarousel from "./ProductInfoCarousel";
import GetGiftForm from "./GetGiftForm";
import ProductSection from "./ProductSection";
import * as ga from "methods/ga";

import { HomeConfig } from "config/homeConfig";

const Wrapper = styled.div`
  background-color: ${COLOR.backgroundPrimary};
`;

export const ModalContent = ({ type, setExchangeModal }) => {
  const {
    auth: { userId },
  } = useAuth();
  const goExpore = () => {
    ga.sendGAEvent(userId, ga.GaEventType.EXPLORE);
    ga.gtmButtonClick(ga.ButtonType.SUBMITED);
    setExchangeModal(false);
  };

  const goLineOa = () => {
    window.location.replace(lineOAUrl);
  };

  switch (type) {
    case "submit":
      return (
        <div>
          <Typography variant="body1" color="white" align="center">
            填寫完成
          </Typography>
          <div className="line" />
          <Typography variant="body1" color="white" sx={{ fontSize: "1.2rem" }}>
            感謝您的填寫，資料已送出，提醒您記得向指定櫃點預約諮詢時間，並兌換「魚子奢華體驗禮」乙份。
          </Typography>
          <WhiteButton block onClick={goLineOa}>
            回到La Prairie官方帳號
          </WhiteButton>
        </div>
      );
    case "submited":
      return (
        <div>
          <Typography variant="body1" color="white">
            謝謝您的參與，點擊探索更多新品「魚子美顏緊俏美眼精華」。
          </Typography>
          <WhiteButton sx={{ border: 0 }} block onClick={goExpore}>
            探索更多
          </WhiteButton>
          <WhiteButton sx={{ border: 0 }} block onClick={goLineOa}>
            回到La Prairie官方帳號
          </WhiteButton>
        </div>
      );
    default:
      return <div />;
  }
};

const HomePage = () => {
  const [stores, setStores] = useState([]);
  const [modalOpen, setOpen] = useState("");
  const [isNotRedeemed, setIsNotRedeemed] = useState(false);
  const { withLoading } = useLoading();
  const {
    profile: { userId },
    isActivityEnd,
    userVerify,
  } = useAuth();
  useEffect(() => {
    // Avoid the redirecting modal open
    if (userVerify !== customerStatus.NOT_REDEEMED) {
      setIsNotRedeemed(true);
    }
  }, []);
  useEffect(() => {
    if (isActivityEnd) {
      setOpen(false);
      return;
    }
    if (!userVerify) return;
    if (userVerify && userVerify !== customerStatus.UNAUTHORIZED) {
      setOpen("submited");
    } else {
      if (localStorage.getItem(GA_UTM_SOURCE) === GO_FORM_UTM_SOURCE) {
        setTimeout(() => {
          goForm();
        }, 1500);
      }

      withLoading(
        Client.getStores(userId)
          .then((storeResp) => {
            const storesList = lodashGet(storeResp, "data.rows", []).sort(
              (a, b) => a.order - b.order
            );
            setStores(storesList);
          })
          .catch((error) => {
            console.log(error);
          })
      );
      setOpen("");
    }
  }, [userVerify, isActivityEnd]);

  const goForm = () => {
    document.getElementById("la-prairie-form").scrollIntoView();
  };

  return (
    <Wrapper>
      <Header />
      <Logo />
      <ContentInfo />
      <ProductInfoCarousel />
      {/* <ProductCarousel /> */}
      <ProductSection />
      <Video
        showControls={true}
        title={HomeConfig.videoSection.title}
        poster={HomeConfig.videoSection.poster}
        video={HomeConfig.videoSection.video}
      />
      {userVerify === customerStatus.UNAUTHORIZED && (
        <GetGiftForm
          stores={stores}
          setExchangeModal={setOpen}
          canFillForm={userVerify === customerStatus.UNAUTHORIZED}
        />
      )}
      {/* TODO: use component/Modal */}
      {/* TODO: Modal only open when the activity timeout */}
      {(isNotRedeemed || userVerify === customerStatus.UNAUTHORIZED) && (
        <Modal open={!!modalOpen}>
          <Box sx={ModalStyle}>
            <ModalContent type={modalOpen} setExchangeModal={setOpen} />
          </Box>
        </Modal>
      )}
    </Wrapper>
  );
};

export default HomePage;
